<template>
	<div>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">{{$route.query.inventory == 0 ? 'Expense Items' : $route.query.service_account_item ? 'Service Account Items' : 'Items'}}</v-toolbar-title>

		    <v-spacer></v-spacer>

			<v-btn icon @click="fn_import" v-if="$route.query.inventory!=0 && !$route.query.service_account_item"><v-icon>publish</v-icon></v-btn>

			<v-menu v-if="$route.query.inventory!=0 && !$route.query.service_account_item">
				<v-btn small slot="activator" icon>
					<v-icon>more_vert</v-icon>
				</v-btn>
				<v-list dense nopadding>
					<v-list-tile @click="fn_exportItems">
						<v-icon font20 class="mr-3">file_download</v-icon>
						<v-list-tile-title>Export Items</v-list-tile-title>
					</v-list-tile>
				</v-list>
			</v-menu>
			<v-btn icon @click="fn_itemSettings" v-if="$route.query.inventory!=0 && !$route.query.service_account_item"><v-icon>settings</v-icon></v-btn>
		    <v-btn icon @click="fn_new"><v-icon>add</v-icon></v-btn>

		    <!-- <v-text-field elevation-10  flat solo placeholder="Search..." v-model="searchValue" @input="fn_searchItem" slot="extension" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field> -->
		    <div full-width slot="extension" class="search-filter" :class="{'bottom-shadow':scrollPositionTop!=0}">
		    	<v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" @input="fn_debounceSearch"></v-text-field>

		    	<!-- <div v-ripple class="filter-btn" @click="fn_getBottomMenu(null, 904)"> -->
		    	<div v-ripple class="filter-btn" @click="fn_openDialogFilterItems">
		    		<v-icon>filter_list</v-icon>
		    		<span style="font-size: 48px;position: absolute;bottom: -6px;right: 6px;color: #4b77be;" v-if="selectionItems.selectedFilterItemValue != null || selectionItems.selectedSortValue">&bull;</span>
		    	</div>
		    </div>
		</v-toolbar>

		<div class="hasToolbar hasExtension grey-back" v-scroll="onScroll">


			<!-- <v-list nopadding grey-back>

				<v-subheader white-background subheader-ultra-dense>
					Count {{$root.numberToLocale(listItemObject.totalCount)}}
				</v-subheader>

				<v-divider></v-divider>

				<div white-background v-for="(item, index) in listItemObject.items" :key="index" :id="'item_'+item.productId">
					<v-list-tile class="right-subtitle-tile">
					    <v-list-tile-content @click="fn_itemClick(item.productId, index)">
					      <v-list-tile-title class="mb-1">{{item.name}}</v-list-tile-title>
					    </v-list-tile-content>

					    <v-list-tile-action>
					    	<v-btn icon flat @click="fn_getBottomMenu(null, 902, item.isSystem)">
				                <v-icon>more_vert</v-icon>
				            </v-btn>
					    </v-list-tile-action>
					</v-list-tile>

					<v-divider v-if="listItemObject.items.length-1 != index"></v-divider>
				</div>

			</v-list> -->

			<v-list grey-back three-line nopadding>

				<v-subheader style="position: sticky;top: 104px;z-index: 1;" white-background subheader-dense>
					Count: {{$root.numberToLocale(listItemObject.totalCount, 1)}}
					<v-spacer></v-spacer>

					<div class="font11 mr-2" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" @click="fn_openBrands" v-ripple v-if="$route.query.inventory!=0">
						<div style="max-width: 60px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{selectionItems.brandName ? selectionItems.brandName : 'Brand'}}</div>
						<v-icon>arrow_drop_down</v-icon>
					</div>

					<div class="font11 mr-2" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" @click="fn_openCompanies" v-ripple v-if="$route.query.inventory!=0">
						<div style="max-width: 60px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{selectionItems.companyName ? selectionItems.companyName : 'Company'}}</div>
						<v-icon>arrow_drop_down</v-icon>
					</div>

					<div class="font11" style="padding-left: 8px;display: flex;align-items: center;border: 1px #ddd solid;border-radius: 5px;" @click="fn_openCategories" v-ripple>
						<div style="max-width: 60px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{selectionItems.categoryName ? selectionItems.categoryName : 'Category'}}</div>
						<v-icon>arrow_drop_down</v-icon>
					</div>

				</v-subheader>

				<v-subheader v-if="showStrip && $route.query.inventory!=0" @click="fn_import" class="video-link-tile import_strip" primary-color subheader-semi-dense><v-icon color="primary" font20 class="mr-2">publish</v-icon> Import Items <v-spacer></v-spacer> <v-icon color="primary" font20 @click="fn_removeImportStrip">close</v-icon></v-subheader>

				<!-- <div white-background full-width nopadding v-if="showStrip && $route.query.inventory!=0">
					<v-subheader @click="fn_import" class="video-link-tile import_strip" primary-color subheader-semi-dense><v-icon color="primary" font20 class="mr-2">publish</v-icon> Import Items <v-spacer></v-spacer> <v-icon color="primary" font20 @click="fn_removeImportStrip">close</v-icon></v-subheader>
					<v-divider></v-divider>
					<v-list-tile class="video-link-tile two-line pt-0 pb-0" @click.native="fn_openVideo" avatar>
						<v-list-tile-content>
							<v-list-tile-title font14>How to import items in BizOps App?</v-list-tile-title>
							<v-list-tile-sub-title font12 light-opacity-color>Watch Video <v-icon class="ml-1 font14" style="border-radius: 50%;background: rgb(66, 165, 245);color: #fff !important;">chevron_right</v-icon></v-list-tile-sub-title>
						</v-list-tile-content>
					</v-list-tile>
				</div> -->

				<v-divider v-else></v-divider>

				<div white-background v-for="(item, index) in listItemObject.items" :key="index" :class="{'margin-top-ten':index!=0}" :id="'item_'+item.productId">
					<v-list-tile v-ripple @click="fn_itemClick(item.productId, index)">

					    <v-list-tile-content>
					      	<v-list-tile-title class="mb-1">{{item.productName}}</v-list-tile-title>
					      	<v-list-tile-sub-title dark-opacity-color v-if="item.groupTypeId == 101">
					      		Purchase Rate: &#8377; {{item.purchasePrice ? $root.numberToLocale(roundUpto2Decimals(item.purchasePrice)) : '0'}}
					      	</v-list-tile-sub-title>

					      	<v-list-tile-sub-title dark-opacity-color v-if="item.groupTypeId == 101">
					      		Sale Price: &#8377; {{item.sellingPrice ? $root.numberToLocale(roundUpto2Decimals(item.sellingPrice)) : '0'}}
					      	</v-list-tile-sub-title>

					      	<v-list-tile-sub-title dark-opacity-color v-if="item.groupTypeId == 102">
					      		Charges: &#8377; {{item.charges ? $root.numberToLocale(roundUpto2Decimals(item.charges)) : '0'}}
					      	</v-list-tile-sub-title>

							<v-chip small v-if="item.status == 0">De-Activated</v-chip>
					    </v-list-tile-content>

					    <v-list-tile-action style="padding:10px 0px" v-if="item.groupTypeId == 101">
						    <div></div>

					    	<div :class="{'redcolor': item.currentStock <= 0}">
					    		{{item.currentStock ? item.currentStock : 0}} {{item.unitName}}
					    	</div>
			            	
			            </v-list-tile-action>

					</v-list-tile>

					<!-- <template v-if="item.inventory && item.groupTypeId==101"> -->
						<v-divider></v-divider>
						<div right-align style="padding:2px 6px">
							<template v-if="item.inventory && item.groupTypeId==101">
								<v-btn nomargin icon flat @click="fn_adjustStock('plus', item.productId, index)"><v-icon font20>add_circle_outline</v-icon></v-btn>
								<v-btn nomargin icon flat @click="fn_adjustStock('minus', item.productId, index)"><v-icon font20>remove_circle_outline</v-icon></v-btn>
							</template>

							<v-menu dense left>
								<v-btn small slot="activator" icon>
									<v-icon>more_vert</v-icon>
								</v-btn>

								<v-list nopadding>
									<v-list-tile @click="fn_copy(item.productId)">
										<v-list-tile-title>Copy</v-list-tile-title>
									</v-list-tile>
								</v-list>
							</v-menu>
					    </div>	
					<!-- </template> -->
					

				</div>


			</v-list>

			<transition name="fade" mode="out-in">

				<v-card noshadow class="create-placeholder-card" v-if="showPlaceHolder && !listItemObject.totalCount">
					<v-card-text @click="fn_new">

						<div center-align>
			            	<div v-ripple class="placeholder-icon">
			            		<i aria-hidden="true" class="v-icon material-icons add-icon">add</i>
			            		<img src="../../../../assets/icon_wallet.svg" alt="">
			            	</div><br>

			            	<p class="title light-opacity-color">Create New {{$route.query.inventory == 0 ? 'Expense Item' : 'Item'}}</p>
			            </div>
					</v-card-text>
				</v-card>
				
				<!-- <v-card noshadow v-if="showPlaceHolder && !listItemObject.totalCount" style="height: calc(100vh - 162px);display: flex;align-items: center;">
					<v-card-text>

						<div center-align>
			            	<div @click="fn_new" v-ripple style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px;position:relative">
			            		<i aria-hidden="true" class="v-icon material-icons" style="position: absolute;top: 0;right: 0px;background: #4b77be !important;border-radius: 50%;color: #fff !important;font-size: 20px;">add</i>
			            		<img src="../../../../assets/icon_wallet.svg" style="opacity:0.6;width:42px" alt="">
			            	</div><br>

			            	<p class="title light-opacity-color" style="line-height:28px !important">Create New {{$route.query.inventory == 0 ? 'Expense Item' : 'Item'}}</p>
			            </div>

					</v-card-text>
				</v-card> -->
			</transition>

			<!-- <div class="display_msg" v-if="!listItemObject.items.length">There are no items</div> -->
		</div>

		<dialog-filter-items ref="ref_dialogFilterItems" type="Items" :filterData="filterData" :setFilter="fn_setFilter" :selectedFilterItemValue="selectionItems.selectedFilterItemValue" :selectedSortValue="selectionItems.selectedSortValue" :deactivatedOnly="selectionItems.showOnlyDeactivated"></dialog-filter-items>
		<dialog-selection-list ref="ref_dialogSelectionList" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-selection-list>
	</div>
</template>

<script>
var tagId = null;
const menuItem = require('../../../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../../../config.js').configs.bottomSheetMenu;
import {masterMixin} from '../../master_mixin.js'

const transactionForms = require('../../../../config.js').configs.transactionForms;

const dialogjs =  require('../../../masters/forms/dialog').dialogjs;
const listIdObject = require('../../../../config.js').configs.mastersPredefinedLists;

import dialogFilterItems from '../../../activity/dialogs/dialog_filter';
import dialogSelectionList from '../../../dialogs/dialog_selection_list'

	export default{
		mixins: [masterMixin],
		data(){
			return{
				toolbarTitle:"Items",

				// iconpath:null,
				formId:null,
				dialogStorageId:null,

				selectionItems:{
					brandId:null,
					brandName:null,
					categoryId:null,
					categoryName:null,
					companyId:null,
					companyName:null,
					selectedFilterItemValue:null,
					selectedSortValue:0,
					showOnlyDeactivated:false
				},

				backButtonPress:false,

				filterData:{
					filterItems:[
						{"filterItemId":1, "name":"All", "value":null},
						{"filterItemId":2, "name":"In Stock", "value":1},
						{"filterItemId":3, "name":"Not In Stock", "value":0}
					],
					sortItems:[
						{"sortId":1, "name":"Item Name", "value":0},
						{"sortId":2, "name":"Stock - High to Low", "value":1},
						{"sortId":3, "name":"Stock - Low to High", "value":2}
					],
				},

				showStrip:false
			}
		},
		components: {
		    'dialog-filter-items': dialogFilterItems,
			'dialog-selection-list':dialogSelectionList
		},
		methods:{

			fn_import: function(){
				// this.$router.push({path:"/masters/inventory/productandservices/items/import"});
				if(this.$root.appVersion >= 117){
					this.$router.push({path:"/masters/inventory/productandservices/items/import"});
				}
				else{
					this.$eventHub.$emit('AppUpdateDialog');
				}
			},

			fn_removeImportStrip: function(event){
				event.stopPropagation();
				this.showStrip = false;
				localStorage.setItem('remove_import_item_strip', 1);
			},

			fn_copy: function(productId){
				this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), itemId:productId, copy:true}});
			},

			fn_itemClick: function (itemId, index) {
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = index + 1;
				localStorage.setItem("activity_items_state", JSON.stringify(obj));
				// tagId id form future use
				// itemName id form future use
				this.$router.push('/masters/inventory/productandservices/items/'+itemId);
			},

			fn_adjustStock(type, productId, index){
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = index + 1;
				localStorage.setItem("activity_items_state", JSON.stringify(obj));

				this.$router.push({path:"/transactions/inventory/stockadjustment/items/new", query:{tagId:this.guidWeb(), type:type, itemid:productId}});
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			},

			fn_itemSettings: function(){
				this.$router.push({path:"/settings/business/transactionnew", query:{"item":1}});
			},

			fn_new: function(){
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = this.listItemObject.items.length;
          		localStorage.setItem("activity_items_state", JSON.stringify(obj));

				if(this.$route.query.service_account_item){
					this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), inventory:this.$route.query.inventory != undefined ? this.$route.query.inventory : 1, service_account_item:1}});
				}
				else{
					this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), inventory:this.$route.query.inventory != undefined ? this.$route.query.inventory : 1}});
				}
			},

			fn_menuItemClick: function(tagId, menuId, menuAction, itemId){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit'){
					this.$router.push("/masters/inventory/productandservices/items/"+itemId+"/edit");
				}
				else if(menuAction=='copy'){
					this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), itemId:itemId, copy:true}});
				}
				else if(menuAction=='draft'){
					// this.$router.push({path:'/drafts', query:{category:"Products", tabIndex:0}});
					this.$router.push({path:'/drafts', query:{tabIndex:0}});
				}
				else if(menuAction=='delete'){
					let self = this;
					this.fn_deleteMasterItem('products', itemId, function(response){
						if(response){
	                        self.showToast('Item deleted');
	                    }
	                    else{
	                        self.showToast("Item cannot be deleted as already in use");
	                    }
					})
				}
				else if(menuAction == 'clearallfilters'){
					this.fn_clearAll();
				}
			},

			fn_openCategories: function(){
				let obj = {};
				obj.functionName = 'productCategories';
				obj.toolbarTitle = 'Select Category';
				obj.itemId = this.selectionItems.categoryId;
				obj.itemName = this.selectionItems.categoryName;
				this.fn_openDialogAndroid('android', 'DialogFilter', 'ref_category', obj);
			},
			// fn_openCategories: function(){
			// 	let viewDialogObject = { ToolbarTitle:"Category", fnName:"ProductCategoryDialog", ref:"ref_category", dbSearch:true };
			// 	if(this.selectionItems.categoryId && this.selectionItems.categoryName){
			// 		viewDialogObject.selectedItem = {"itemId":this.selectionItems.categoryId, "itemName":this.selectionItems.categoryName};
			// 		viewDialogObject.clearBtn = true;
			// 	}
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));
			// 	this.fn_openDialogWeb('web', 'Account Group', 'ref_dialogSelectionList');
			// },

			fn_openBrands: function(){
				let obj = {};
				obj.functionName = 'listItems';
				obj.toolbarTitle = 'Select Brand';
				obj.itemId = this.selectionItems.brandId;
				obj.itemName = this.selectionItems.brandName;
				this.fn_openDialogAndroid('android', 'DialogFilter', 'ref_brand', obj);
			},
			// fn_openBrands: function(){
			// 	let viewDialogObject = { ToolbarTitle:"Brand", fnName:"ListItemDialog", ref:"ref_brand", dbSearch:true };
			// 	viewDialogObject.listId = listIdObject.brandListGUID;
			// 	if(this.selectionItems.brandId && this.selectionItems.brandName){
			// 		viewDialogObject.selectedItem = {"itemId":this.selectionItems.brandId, "itemName":this.selectionItems.brandName};
			// 		viewDialogObject.clearBtn = true;
			// 	}
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));
			// 	this.fn_openDialogWeb('web', 'Brand', 'ref_dialogSelectionList');
			// },

			fn_openCompanies: function(){
				let obj = {};
				obj.functionName = 'listItems';
				obj.toolbarTitle = 'Select Company';
				obj.itemId = this.selectionItems.companyId;
				obj.itemName = this.selectionItems.companyName;
				this.fn_openDialogAndroid('android', 'DialogFilter', 'ref_company', obj);
			},
			// fn_openCompanies: function(){
			// 	let viewDialogObject = { ToolbarTitle:"Company", fnName:"ListItemDialog", ref:"ref_company", dbSearch:true };
			// 	viewDialogObject.listId = listIdObject.companyListGUID;
			// 	if(this.selectionItems.companyId && this.selectionItems.companyName){
			// 		viewDialogObject.selectedItem = {"itemId":this.selectionItems.companyId, "itemName":this.selectionItems.companyName};
			// 		viewDialogObject.clearBtn = true;
			// 	}
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));
			// 	this.fn_openDialogWeb('web', 'Company', 'ref_dialogSelectionList');
			// },

			// fn_clearAll: function(){
			// 	this.selectionItems.categoryId = null;
			// 	this.selectionItems.brandId = null;
			// 	this.selectionItems.companyId = null;
			// 	localStorage.removeItem('item_filter');
			// 	this.fn_filterData();
			// },

			// fn_itemClick: function (tagId, itemId, itemName) {
			// 	// tagId id form future use
			// 	// itemName id form future use
			// 	this.$router.push('/masters/inventory/productandservices/items/'+itemId);
			// },

			fn_getBottomMenu: function (tagId, elementId, isSystem) {
				let bottomMenu;

				if(elementId == bottomSheetMenu.toolBar.Id){
					bottomMenu = {"BottomMenu": [menuItem.help]};
				}
				else if(elementId == bottomSheetMenu.masterListItems.Id){
					bottomMenu = {"BottomMenu": [menuItem.edit, menuItem.copy]};
					// !Number(isSystem) ? bottomMenu.BottomMenu.push(menuItem.delete) : '';
				}
				else if(elementId == bottomSheetMenu.moreFilters.Id){
					menuItem.filterCategory.selectedItem = this.selectionItems.categoryId ? this.selectionItems.categoryName : null;
					menuItem.filterBrand.selectedItem = this.selectionItems.brandId ? this.selectionItems.brandName : null;
					menuItem.filterCompany.selectedItem = this.selectionItems.companyId ? this.selectionItems.companyName : null;

					if(this.$route.query && this.$route.query.inventory == 0){
						bottomMenu = {"BottomMenu": [menuItem.filterCategory]};
					}
					else{
						bottomMenu = {"BottomMenu": [menuItem.filterCategory, menuItem.filterBrand, menuItem.filterCompany]};
					}
					
					if(this.selectionItems.categoryId || this.selectionItems.brandId || this.selectionItems.companyId){
						bottomMenu.BottomMenu.push(menuItem.clearAll);
					}
				}
				
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_openDialogAndroid: function (platform, name, ref, obj) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = obj.toolbarTitle;
				viewDialogObject.isBottomMenu = false;

				if(ref == 'ref_brand'){
					viewDialogObject.listId = listIdObject.brandListGUID;
				}
				else if(ref == 'ref_company'){
					viewDialogObject.listId = listIdObject.companyListGUID;
				}

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(obj.itemId && obj.itemName){
					paramObject.defaultValue = {"id":obj.itemId, "name":obj.itemName};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, obj.functionName, tagId, paramObject, ref);
				
			},

			fn_setFilter: function(filterItemId, sortId, showDeactivated){
				this.selectionItems.selectedFilterItemValue = filterItemId;
				this.selectionItems.selectedSortValue = sortId;
				this.selectionItems.showOnlyDeactivated = showDeactivated;
				this.fn_closeDialog();
				this.fn_searchItem();
			},

			fn_openDialogFilterItems: function(){
				this.fn_openDialogWeb('web', 'FilterItems', 'ref_dialogFilterItems');
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialog: function () {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},
			
			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				if(ref == 'ref_brand'){
					this.selectionItems.brandId = !isRemoved ? selectedValueId : null;
					this.selectionItems.brandName = !isRemoved ? selectedValueName : null;
				}
				else if(ref == 'ref_category'){
					this.selectionItems.categoryId = !isRemoved ? selectedValueId : null;
					this.selectionItems.categoryName = !isRemoved ? selectedValueName : null;
				}
				else if(ref == 'ref_company'){
					this.selectionItems.companyId = !isRemoved ? selectedValueId : null;
					this.selectionItems.companyName = !isRemoved ? selectedValueName : null;
				}

				isRemoved ? this.fn_closeDialog() : '';
				// this.fn_filterData(true);
				this.fn_searchItem();
			},

			// fn_filterData: function(cacheData){
			// 	let filterObject = {};
			// 	this.selectionItems.categoryId ? filterObject.categories = [this.selectionItems.categoryId] : '';
			// 	this.selectionItems.brandId ? filterObject.brands = [this.selectionItems.brandId] : '';
			// 	this.selectionItems.companyId ? filterObject.companies = [this.selectionItems.companyId] : '';
			// 	filterObject.inventory = this.$route.query.inventory != undefined ? this.$route.query.inventory : 1;
			// 	cacheData ? localStorage.setItem('item_filter', JSON.stringify(this.selectionItems)) : '';
			// 	this.refreshData('productAndServices', tagId, filterObject);
			// },

		 	fn_loadItems: function() {
				this.loadMore = true;
		    	let filterObject = {};
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				filterObject.search = this.searchValue ? this.searchValue.toLowerCase() : '';

				filterObject.inventory = this.$route.query.inventory != undefined ? this.$route.query.inventory : 1;
				
				filterObject.stockType = this.selectionItems.selectedFilterItemValue;
				filterObject.sortByStock = this.selectionItems.selectedSortValue;
				filterObject.showOnlyDeactivated = this.selectionItems.showOnlyDeactivated

				filterObject.categories = this.selectionItems.categoryId ? [this.selectionItems.categoryId] : [];
				filterObject.brands = this.selectionItems.brandId ? [this.selectionItems.brandId] : [];
				filterObject.companies = this.selectionItems.companyId ? [this.selectionItems.companyId] : [];

				let pageState = null;
				if(localStorage.getItem("activity_items_state")){
					pageState = JSON.parse(localStorage.getItem("activity_items_state"));
					filterObject.limit = 50 - (pageState.itemIndex % 50) + pageState.itemIndex;
				}

				localStorage.setItem('item_filter', JSON.stringify(this.selectionItems));

				if(this.$route.query.service_account_item){
					filterObject.serviceAccountItem = true;
				}

				let self = this;
				this.getItems("ItemList", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							let responseJson = JSON.parse(response);
							self.listItemObject.totalCount = responseJson.totalCount;

							for(let i in responseJson.items){
								let itemIndex = self.listItemObject.items.findIndex(item => item.productId==responseJson.items[i].productId);

								if(itemIndex==-1){
									self.listItemObject.items.push(responseJson.items[i]);	
								}
							}

							console.log(pageState);
							if(pageState && pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":0, "offset":-112, "easing":"linear"};
									self.$vuetify.goTo('#item_'+pageState.itemId, scrollOptions);
									localStorage.removeItem("activity_items_state");
								},100);
							}

							if(pageState && !pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":300, "offset":0, "easing":"linear"};
									self.$vuetify.goTo(pageState.lastScrollPos, scrollOptions);
									localStorage.removeItem("activity_items_state");
								},100);
							}

							self.startIndex = self.listItemObject.items.length;
							self.loadMore = false;

							setTimeout(function(){
								self.showPlaceHolder = true;
							},300);
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
						}
					}
				)
		    },

		    fn_searchItem: function () {
				this.startIndex = 0;
				this.listItemObject.items = [];
				this.fn_loadItems(true);
			},

			fn_showWebView: function () {
				var viewObject = {};

				var tagId = null;
				this.$route.params && this.$route.query.tagId ? tagId = this.$route.query.tagId : '';
				var self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction, itemId) {
							self.fn_menuItemClick(tagId, menuId, menuAction, itemId)
						}
					}
				);
			},

			fn_exportItems: function(){
				var self = this;
				this.showLoading("Please wait...");
				this.getData('GetExportItems', null, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							if(data && data.items && data.items.length){
								self.fn_processItems(data.items);	
							}
				        }, 
				        onError: function(error){
				          	console.log(error);
							self.hideLoading();
							self.showToast("Something went wrong. Try again.");
				        }
					}
		        );
			},

			fn_processItems: function(items){
				let sheetArray = [];
				let headerRow = ["Name", "Code", "Type", "Charges", "GST 2.0 Percentage", "Cess 2.0 Percentage", "GST 1.0 Percentage", "Cess 1.0 Percentage", "HSN Code", "Unit", "Selling Price", "Wholesale Price", "Purchase Rate", "Opening", "Opening Rate", "Category", "Description", "Brand", "Company"];

				if(this.$root.TransactionSettings.mrpWiseStock){
					headerRow = ["Name", "Code", "Type", "Charges", "GST 2.0 Percentage", "Cess 2.0 Percentage", "GST 1.0 Percentage", "Cess 1.0 Percentage", "HSN Code", "Unit", "MRP", "Selling Price", "Wholesale Price", "Purchase Rate", "Opening", "Opening Rate", "Category", "Description", "Brand", "Company"];
				}

				sheetArray.push(headerRow);
				for(let i=0; i<items.length; i++){
					let row = [];
					row.push(items[i].name);
					row.push(items[i].itemCode);
					row.push(items[i].groupTypeId == 101 ? 'Product': 'Service');
					row.push(items[i].charges ? Number(items[i].charges) : null);
                    row.push(items[i].newGstPercentage ? Number(items[i].newGstPercentage) : null);
					row.push(items[i].newCessPercentage ? Number(items[i].newCessPercentage) : null);
					row.push(items[i].gstPercentage ? Number(items[i].gstPercentage) : null);
					row.push(items[i].cessPercentage ? Number(items[i].cessPercentage) : null);
					row.push(items[i].hsnCode);
					row.push(items[i].unitName);
					if(this.$root.TransactionSettings.mrpWiseStock){
						row.push(items[i].mrp ? Number(items[i].mrp) : null);
					}
					row.push(items[i].sellingPrice ? Number(items[i].sellingPrice) : null);
					row.push(items[i].wholeSalePrice ? Number(items[i].wholeSalePrice) : null);
					row.push(items[i].purchaseRate ? Number(items[i].purchaseRate) : null);
					row.push(items[i].openingValue ? Number(items[i].openingValue): null);
                    row.push(null);//opening rate blank col
					row.push(items[i].categoryName);
					row.push(items[i].description);
					row.push(items[i].brandName);
					row.push(items[i].companyName);
					sheetArray.push(row);
				}

				const XlsxPopulate = require('xlsx-populate');
				XlsxPopulate.fromBlankAsync().then(workbook => {
					workbook.sheet(0).cell("A1").value(sheetArray);
					workbook.sheet(0).name('Items');
					let range = "A1:S1";
					if(this.$root.TransactionSettings.mrpWiseStock){
						range = "A1:T1";
					}
					workbook.sheet(0).range(range).style({"fill": "92D050", "bold": true});
					workbook.outputAsync("base64").then(base64=> {
						let raw = window.atob(base64);
						let rawLength = raw.length;
						let array = new Uint8Array(new ArrayBuffer(rawLength));

						for(let i = 0; i < rawLength; i++) {
							array[i] = raw.charCodeAt(i);
						}

						let fileName = "items_"+this.$root.fn_getCurrentDateTimeString();
        
						let chunkcounter = 0;
						if(typeof AndroidRoutingTest !== "undefined" && AndroidRoutingTest !== null){
							console.log('inside');

							//opening file
							let fileId = this.guidWeb();
							AndroidRoutingTest.openFile(fileId, fileName+'.xlsx');

							//writing file
							let chunkSize = array.BYTES_PER_ELEMENT * 1000 * 2; //self.$parent.datachunksize //1 byte
							for (let i = 0; i < array.length; i += chunkSize) {
								let datachunk = array.slice(i, i + chunkSize)
								AndroidRoutingTest.writeFile(fileId, datachunk);
								console.log(++chunkcounter);
							}

							//closing file
							console.log("close");
							this.hideLoading();
							this.fn_closeAndExportExcelFile(fileId);
						}
					});
				})
			},

			fn_closeAndExportExcelFile: function(fileId){
				let self = this;
				this.closeFile(fileId, {
					onSuccess: function(response){
						console.log(response);
						self.snackbar = true;
						self.showToast('File downloaded ' + response);
					}, 
					onError: function(error){
						console.log(error);
						self.showToast('File download failed');
					}
				});
			},

			// fn_openVideo: function(){
			// 	this.$root.fn_openExternalUrl("https://www.youtube.com/watch?v=nYB7UiTFR88&t=36s");
			// }
		},
		mounted: function(){

			this.fn_showWebView();

			this.showStrip = localStorage.getItem('remove_import_item_strip') ? false : true;

			if(this.$route.query && this.$route.query.inventory == 0){
				this.toolbarTitle = "Expense Items";
			}

			tagId = this.$route.query.tagId;
			this.formId = this.$route.query.tagId;
			this.dialogStorageId = 'dialog_'+this.formId;

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;

			if(localStorage.getItem('item_filter')){
				let data = JSON.parse(localStorage.getItem('item_filter'));
				this.selectionItems.brandId = data.brandId ? data.brandId : null;
				this.selectionItems.brandName = data.brandName ? data.brandName : null;
				this.selectionItems.categoryId = data.categoryId ? data.categoryId : null;
				this.selectionItems.categoryName = data.categoryName ? data.categoryName : null;
				this.selectionItems.companyId = data.companyId ? data.companyId : null;
				this.selectionItems.companyName = data.companyName ? data.companyName : null;

				this.selectionItems.selectedFilterItemValue = data.selectedFilterItemValue ? data.selectedFilterItemValue : null;
				this.selectionItems.selectedSortValue = data.selectedSortValue ? data.selectedSortValue : 0;
				this.selectionItems.showOnlyDeactivated = data.showOnlyDeactivated ? data.showOnlyDeactivated : false;
			}

			this.fn_loadItems();
		},
		beforeRouteLeave (to, from, next) {
		  	var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
				dialogjs.fn_checkAndCloseOpenDialogs(this);
				this.backButtonPress = false;
				next(false);
			}
		  	else {
		  		this.backButtonPress ? localStorage.removeItem('item_filter') : '';
		  		next();
		  	}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/product/items.vue